var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"gongwuchetab"},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,class:{active:_vm.now==item.id},on:{"click":function($event){return _vm.change(item)}}},[_vm._v("\n    "+_vm._s(item.name)+"\n")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ee3a2a1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/kanban/abc/tab.vue
// module id = null
// module chunks = 